import { createTheme, Theme } from '@mui/material';

export const theme = createTheme({
  palette: {
    grey: {
      100: '#F8F8F8',
      200: '#E7E7E7',
      700: '#898989',
    },
    primary: {
      main: '#798ED9',
      dark: '#1976D2',
      light: '#53536D',
    },
    secondary: {
      main: '#9C27B0',
      dark: 'rgba(25, 118, 210, 0.12)',
    },
    success: {
      main: '#55A938',
    },
    warning: {
      main: '#ED6C02',
      light: '#E17B6D',
    },
  },
}) as Theme;
